import { FormStyle, getLocaleDayPeriods, TranslationWidth } from '@angular/common';
      import * as momentImported from 'moment';
      
      export class TimeMaskHelper {
      
          static getMask(locale: string, format: string, meridian: boolean, getMomentWithLocale: (...args: any[]) => momentImported.Moment) {
              // ['AM', 'PM']
              // ['a. m.', 'p. m.']
              // ['午前', '午後']
              // ['上午', '下午']
              // ['vorm.', 'nachm.']
              var dayPeriods = getLocaleDayPeriods(locale, FormStyle.Standalone, TranslationWidth.Narrow);
      
              var morningDayPeriodString = dayPeriods[0]; // 'AM'
              var afternoonDayPeriodString = dayPeriods[1]; // 'PM'
      
              let firstSymbolDayPeriodMaskRegEx: RegExp;
      
              const firstMorningSymbol = morningDayPeriodString[0];
              const firstAfternoonSymbol = afternoonDayPeriodString[0];
      
              if (firstMorningSymbol.toLowerCase() != firstAfternoonSymbol.toLowerCase()) {
                  firstSymbolDayPeriodMaskRegEx = TimeMaskHelper.getCaseInsensitiveRegex(firstMorningSymbol, firstAfternoonSymbol);
              }
              else {
                  firstSymbolDayPeriodMaskRegEx = TimeMaskHelper.getCaseInsensitiveRegex(firstMorningSymbol);
              }
      
              const morningDayPeriodMaskRegEx = [firstSymbolDayPeriodMaskRegEx];
              const afternoonDayPeriodMaskRegEx = [firstSymbolDayPeriodMaskRegEx];
      
              morningDayPeriodString.split('').slice(1).forEach(x => {
                  var currentPositionRegex = TimeMaskHelper.getCaseInsensitiveRegex(x);
                  morningDayPeriodMaskRegEx.push(currentPositionRegex);
              });
      
              afternoonDayPeriodString.split('').slice(1).forEach(x => {
                  var currentPositionRegex = TimeMaskHelper.getCaseInsensitiveRegex(x);
                  afternoonDayPeriodMaskRegEx.push(currentPositionRegex);
              });
      
              const maskFunc = ((displayValue: string) => {
                  let mask;
      
                  if (meridian === true) {
                      if (displayValue && displayValue.trim()) {
      
                          const allDayPeriodsRegex = TimeMaskHelper.getCaseInsensitiveRegexImpl([morningDayPeriodString, afternoonDayPeriodString], '+'); // /[vorm\\.nach]+/i
                          const dayPeriodMatch = displayValue.match(allDayPeriodsRegex);
                          const dayPeriod = dayPeriodMatch && dayPeriodMatch.length ? dayPeriodMatch[0].trim() : morningDayPeriodString;
      
                          const morningDayPeriodMaskFullRegEx = TimeMaskHelper.getDayPeriodMaskFullRegEx(format, morningDayPeriodMaskRegEx, displayValue, getMomentWithLocale);
                          const afternoonDayPeriodMaskFullRegEx = TimeMaskHelper.getDayPeriodMaskFullRegEx(format, afternoonDayPeriodMaskRegEx, displayValue, getMomentWithLocale);
      
                          mask = dayPeriod && afternoonDayPeriodString.toLowerCase().startsWith(dayPeriod.toLowerCase())
                              ? afternoonDayPeriodMaskFullRegEx
                              : morningDayPeriodMaskFullRegEx;
                      } else {
                          mask = TimeMaskHelper.getDayPeriodMaskFullRegEx(format, morningDayPeriodMaskRegEx);
                      }
                  }
                  else {
                      let hourPart: any[];
      
                      if (format.toLowerCase().includes('hh')) { // 'hh'
                          hourPart = [/[0-2]/, /[0-9]/];
                      } else { // 'h'
                          if (displayValue && displayValue.trim()) { // user entered value
                              const momentObj = getMomentWithLocale(displayValue, format);
                              const hour = momentObj.hour();
      
                              if (hour == 1 || hour == 2) {
                                  if (displayValue.includes(':')) {
                                      // user decided to move to minutes
                                      hourPart = [new RegExp(hour.toString())];
                                  } else {
                                      // user is still entering hours
                                      hourPart = [new RegExp(hour.toString()), /[0-9:]/];
                                  }
                              } else if (TimeMaskHelper.is2DigitIsoHour(hour)) {
                                  hourPart = [/[0-2]/, /[0-9]/];
                              } else {
                                  hourPart = [/[0-9]/];
                              }
                          } else { // user didn't enter value
                              hourPart = [/[0-9]/];
                          }
                      }
                      //update tslib
                      // mask = [...hourPart, ':', /[0-5]/, /[0-9]/];
                      mask = [hourPart, ':', /[0-5]/, /[0-9]/];
                  }
      
                  return mask;
              }) as any;
      
              return maskFunc;
          }
      
          private static getDayPeriodMaskFullRegEx(format: string, dayPeriodMaskRegEx: RegExp[],
              displayValue: string = null, getMomentWithLocale: (...args: any[]) => momentImported.Moment = null): (RegExp | string)[] {
      
              let dayPeriodMaskFullRegEx: (RegExp | string)[] = [];
      
              format.split('').forEach((x, i) => {
                  if (x == 'h') {
                      if (format[i + 1] == 'h') { // 'hh'
                          dayPeriodMaskFullRegEx.push(/[0-1]/, /[0-9]/);
                      } else if (format[i - 1] != 'h') { // 'h'
      
                          let hour: number;
                          if (displayValue) {
                              const momentObj = getMomentWithLocale(displayValue, format);
                              hour = momentObj.hour(); // 0 - 23
                          }
      
                          if (hour == 1) {
                              if (displayValue.includes(':')) {
                                  // user decided to move to minutes
                                  dayPeriodMaskFullRegEx.push(/[1]/);
                              } else {
                                  // user is still entering hours
                                  dayPeriodMaskFullRegEx.push(/[1]/, /[0-2:]/);
                              }
      
                          } else if (TimeMaskHelper.is2DigitMeridiemHour(hour)) {
                              dayPeriodMaskFullRegEx.push(/[1]/, /[0-2]/);
                          } else {
                              dayPeriodMaskFullRegEx.push(/[0-9]/);
                          }
                      }
                  } else if (x == 'm') {
                      if (format[i + 1] == 'm') {
                          dayPeriodMaskFullRegEx.push(/[0-5]/, /[0-9]/);
                      }
                  } else if (x.toLowerCase() == 'a') {
                      dayPeriodMaskFullRegEx.concat(dayPeriodMaskFullRegEx) //push(...dayPeriodMaskRegEx);
                  } else if (x == '.') {
                      dayPeriodMaskFullRegEx.push('\\\\' + x);
                  } else {
                      dayPeriodMaskFullRegEx.push(x);
                  }
              });
      
              return dayPeriodMaskFullRegEx;
          }
      
          static getCaseInsensitiveRegexImpl(chars: string[], quantifier: string = ''): RegExp {
              chars = (chars as any).flatMap(x => x.length > 1 ? x.split('') : x);
      
              const uniqueCharacters = Array.from(new Set(chars)).map(x => x == '.' ? '\\\\.' : x).join('');
      
              var result = new RegExp(`[${uniqueCharacters}]${quantifier}`, "i");
      
              return result;
          }
      
          private static getCaseInsensitiveRegex(...chars: string[]): RegExp {
              return TimeMaskHelper.getCaseInsensitiveRegexImpl(chars);
          }
      
          private static is2DigitIsoHour(hour: number) {
              return hour >= 10;
          }
      
          private static is2DigitMeridiemHour(hour: number) {
              return hour == 0 // 12 am
                  || (hour >= 10 && hour <= 12) // 10, 11 am, 12 pm
                  || (hour >= 22 && hour <= 24); // 10, 11 pm, 12 am
          }
      }